import React from "react";
import {getPrettyDate} from "./common";

const NotificationListItem = ({ item, onClicked, selected }) => {
    let classes = "email-item";
    if (selected) {
        classes += " selected"
    }

    return (
        <div onClick={() => { onClicked(item.id); }} className={classes}>
            <div className="email-item__unread-dot" data-read={item.isRead}></div>
            <div className="email-item__subject truncate">{item.header}</div>
            <div className="email-item__details">
                <span className="email-item__from truncate">{item.provinceName}</span>
                <span className="email-item__time truncate">{getPrettyDate(item.updateDatetime)}</span>
            </div>
        </div>
    );
}

export default NotificationListItem;